export enum RepliersListingBalcony {
  'Open' = 'Open',
  'None' = 'None',
  'Terrace' = 'Terr',
  'Enclosed' = 'Encl',
  'Juliet' = 'Jlte',

  'Four' = '4', // Almost never used
  'Five' = '5', // Almost never used
  'One' = '1', // Almost never used
  'Three' = '3', // Almost never used
}
